import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
export function ProductOverview() {
  const tomos = [{
    emoji: '🟠',
    title: 'TOMO 1',
    level: 'Fundamentos y Técnicas Base',
    content: 'Ingredientes correctos, materiales seguros y técnicas fundamentales para que tus velas queden perfectas desde el primer intento.',
    image: 'https://cdn.magicpatterns.com/uploads/sahW11RgqbsQNcgjZiwp2T/vela_-_tomo_1.png'
  }, {
    emoji: '🟡',
    title: 'TOMO 2',
    level: 'Sabores Clásicos Argentinos',
    content: 'Dulce de leche, alfajor, mate, facturas, submarino. Los sabores que todo argentino ama, convertidos en velas gourmet irresistibles.',
    image: 'https://cdn.magicpatterns.com/uploads/e82JeBCYFdciowZwHtqbHU/vela_-_tomo_2.png'
  }, {
    emoji: '🟢',
    title: 'TOMO 3',
    level: 'Línea Premium y Gourmet Internacional',
    content: 'Chocolate belga, frutos rojos, limón con jengibre, caramelo salado. Recetas de autor para eventos y clientes que pagan más.',
    image: 'https://cdn.magicpatterns.com/uploads/aLM6adoSeyKyN5KBo8ok91/vela_-_tomo_3.png'
  }, {
    emoji: '🔵',
    title: 'TOMO 4',
    level: 'Línea Salada y de Autor',
    content: 'Manteca y ajo, roquefort, pesto, tomate seco. La línea que diferencia tu negocio y que los restaurantes van a querer en su mesa.',
    image: 'https://cdn.magicpatterns.com/uploads/vZsocZZsDCrQtEVVQG14MT/vela_-_tomo_4.png'
  }, {
    emoji: '🟣',
    title: 'TOMO 5',
    level: 'Fechas Especiales, Regalos y Eventos',
    content: 'Bodas, cumpleaños, baby showers, San Valentín, Día de la Madre. Cómo adaptar tus recetas a ocasiones especiales y cobrar precio premium.',
    image: 'https://cdn.magicpatterns.com/uploads/dkSbAx76Xj8kvpQFkCH4QH/vela_-_tomo_5.png'
  }, {
    emoji: '🔴',
    title: 'TOMO 6',
    level: 'Cómo Vender tus Velas Gourmet',
    content: 'Estrategias reales para vender en Argentina: WhatsApp, Instagram, ferias, catering y eventos. Sin experiencia previa en ventas.',
    image: 'https://cdn.magicpatterns.com/uploads/nTvjZWYu6ucqzR2qvStN1B/vela_-_tomo_6.png'
  }];
  const includes = ['Recetas y técnicas listas para aplicar', 'Explicaciones paso a paso aptas para principiantes', 'Tablas, checklists y registros descargables', 'Adaptado al contexto argentino (ingredientes, precios, proveedores)', 'Lenguaje claro y directo — sin términos de cocina profesional'];
  return <section className="w-full bg-neutral-950 py-4 md:py-8" data-id="element-194">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-195">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-196">
          <div className="text-center mb-3 md:mb-6" data-id="element-197">
            <h2 className="text-3xl md:text-5xl font-bold text-amber-50 mb-1 md:mb-2" data-id="element-198">
              🏆 MEGA PACK VELAS COMESTIBLES GOURMET
            </h2>
            <p className="text-xl md:text-2xl text-amber-400 font-semibold mb-1" data-id="element-199">
              6 Tomos + 3 Bonos — De la cocina al cliente que paga premium
            </p>
            <p className="text-2xl md:text-3xl font-bold text-amber-50" data-id="element-200">
              Todo resuelto. Paso a paso. Desde cero.
            </p>
          </div>

          <div className="mb-4 md:mb-6" data-id="element-201">
            <h3 className="text-2xl md:text-3xl font-bold text-amber-50 mb-3 md:mb-4 text-center" data-id="element-202">
              📚 LOS 6 TOMOS COMPLETOS
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4" data-id="element-203">
              {tomos.map((tomo, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1,
              duration: 0.5
            }} className="bg-neutral-900 border border-amber-900/40 rounded-lg p-4 relative overflow-hidden" data-id="element-204">
                  {tomo.image && <div className="absolute top-2 right-2 w-12 h-16" style={{
                perspective: '500px'
              }} data-id="element-205">
                      <div className="relative w-full h-full rounded-sm shadow-[3px_3px_8px_rgba(0,0,0,0.5)]" style={{
                  transform: 'rotateY(-12deg)',
                  transformStyle: 'preserve-3d'
                }} data-id="element-206">
                        <img src={tomo.image} alt="" className="w-full h-full object-cover rounded-sm" data-id="element-207" />
                        <div className="absolute top-0 left-0 w-[3px] h-full bg-gradient-to-r from-amber-600 to-amber-500 rounded-l-sm" data-id="element-208" />
                        <div className="absolute inset-0 rounded-sm bg-gradient-to-r from-black/20 via-transparent to-transparent pointer-events-none" data-id="element-209" />
                      </div>
                    </div>}
                  <div className="text-3xl mb-2" data-id="element-210">{tomo.emoji}</div>
                  <h4 className={`text-base font-bold text-amber-50 mb-1 ${tomo.image ? 'pr-14' : ''}`} data-id="element-211">
                    {tomo.title}
                  </h4>
                  <p className="text-amber-400 font-semibold mb-2 text-sm" data-id="element-212">
                    {tomo.level}
                  </p>
                  <p className="text-neutral-300 text-sm leading-relaxed" data-id="element-213">
                    {tomo.content}
                  </p>
                </motion.div>)}
            </div>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-neutral-900 border border-amber-900/40 rounded-lg p-4 md:p-6" data-id="element-214">
            <h3 className="text-lg md:text-xl font-bold text-amber-50 mb-2 md:mb-3 text-center" data-id="element-215">
              Cada tomo incluye:
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2" data-id="element-216">
              {includes.map((item, index) => <div key={index} className="flex items-start gap-2" data-id="element-217">
                  <CheckCircleIcon className="w-4 h-4 text-amber-400 flex-shrink-0 mt-0.5" data-id="element-218" />
                  <p className="text-neutral-300 text-sm" data-id="element-219">{item}</p>
                </div>)}
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}